var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var _ = require('lodash');

var container         = '.events-feed';
var target            = '.card .background-image';
var ratio             = 1;

var resize = {

    equalHeight: _.debounce(function(e) {
        $(container).each(function(index) {
            // Set ratio
            $(this).find(target).height($(this).find(target).width() * ratio);

            // Set container height
            //$(this).height($(this).find(target).height());
        });
    }, 100)

};

$(window).on('load', function() { $(container).addClass('load'); });
$(window).on('load resize', _.bind(resize.equalHeight, resize));

module.exports  = function() { /* Nothing to Export */ };
